import React from 'react';
import { Button, Icon, Table, Form, Header, Segment, Popup, Loader, Checkbox, Grid } from 'semantic-ui-react';
import axios from 'axios';
import {
    fetchAcademicYears, fetchStudentStatuses,
    fetchStudyCycle,
    fetchStudyType, fetchStudyYears,
} from '../../Lookups/util';

import ReactExport from 'react-data-export';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from "../../util/PaginationFront";

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


class PreviousSemesterStudents extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

            studyProgramBasicId: null,

            studyCycles: [],

            studyProgramBasics: [],
            studyProgramBasicsAll: [],

            semesters: [],
            academicYears: [],

            students: [],
            loaded: false,
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            excelData:[],

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.filter = this.filter.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    componentDidMount() {
        axios.all([fetchStudyCycle()])
            .then(axios.spread((studyCycleRes) => {


                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                this.setState({
                    studyCycles
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch studyCycles.');
            });

        this.setState({loaded: true})

        axios.post('/students/enrolled-in-previous-not-in-current-semester', { ...obj })
            .then(res => {
                console.log('res', res.data);
                this.setState({
                    students: res.data.map(el => ({ ...el, department: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName : '' })),
                    excelData:  res.data.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.fatherName ? el.fatherName : ''},
                        { value: el.index},
                        { value: el.studyCycleName},
                        { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                    ]))
                });
                this.setState({loaded: false})
            });

        let obj = {};
        axios.post( 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.unsa ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName :''
                })).filter(e => e.studyProgramBasic.archived === false);

                console.log('studyProgramBasics', studyProgramBasics);

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });

    }

    handleInputChange(event, { name, value }) {
        if (value === '') {
            this.setState({
                [name]: null
            });
        }
        this.setState({
            [name]: value
        });

        if (name === 'studyCycleId') {
            if (value === null) this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll });
            this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll.filter(el => el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].id === value : null) });
        }

        if (name === 'studyCycleId' && value === '') { this.setState({ studyCycleId: null, studyProgramBasics: this.state.studyProgramBasicsAll }); }
    }

    filter() {
        this.setState({ loaded: true, results: [] });
        let obj = {
            studyProgramId: this.state.studyProgramBasicId,
        };
         console.log('obj', obj);

            axios.post('/students/enrolled-in-previous-not-in-current-semester', { ...obj })
                .then(res => {
                    console.log('res', res.data);
                    this.setState({
                        students: res.data.map(el => ({ ...el, department: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName : '' })),
                        excelData:  res.data.map(el => ([
                            { value: el.lastName},
                            { value: el.firstName},
                            { value: el.fatherName ? el.fatherName : ''},
                            { value: el.index},
                            { value: el.studyCycleName},
                            { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                            { value: el.studyProgramBasicName},
                            { value: el.studyProgramName},
                        ]))
                    });
                    this.setState({loaded: false})
                });
        }


    getResults(results) {
        if(results.length === 0)
        {
            this.setState({
                excelData:  this.state.students.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.fatherName},
                    { value: el.index},
                    { value: el.studyCycleName},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},

                ]))});
        }
        else{
            this.setState({ results,
                excelData:  results.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.fatherName},
                    { value: el.index},
                    { value: el.studyCycleName},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},

                ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.students;
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Ime oca', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Ciklus', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 150 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'NPP', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];


        return (
            <div>
                {/*<Form>*/}
                {/*    <Form.Group widths="equal">*/}
                {/*        /!*<Form.Field>*!/*/}
                {/*        /!*    <Form.Dropdown*!/*/}
                {/*        /!*        label="Ciklus studija"*!/*/}
                {/*        /!*        clearable*!/*/}
                {/*        /!*        placeholder="Odaberite ciklus"*!/*/}
                {/*        /!*        options={this.state.studyCycles}*!/*/}
                {/*        /!*        onChange={this.handleInputChange}*!/*/}
                {/*        /!*        name="studyCycleId"*!/*/}
                {/*        /!*        value={this.state.studyCycleId}*!/*/}
                {/*        /!*        search*!/*/}
                {/*        /!*        fluid*!/*/}
                {/*        /!*        selection*!/*/}
                {/*        /!*    />*!/*/}
                {/*        /!*</Form.Field>*!/*/}
                {/*        <Form.Field>*/}
                {/*            <Form.Dropdown*/}
                {/*                label="Studijski program"*/}
                {/*                clearable*/}
                {/*                placeholder="Odaberite studijski program"*/}
                {/*                options={this.state.studyProgramBasics}*/}
                {/*                onChange={this.handleInputChange}*/}
                {/*                name="studyProgramBasicId"*/}
                {/*                value={this.state.studyProgramBasicId}*/}
                {/*                search*/}
                {/*                fluid*/}
                {/*                selection*/}
                {/*            />*/}
                {/*        </Form.Field>*/}
                {/*        <Form.Field/>*/}

                {/*    </Form.Group>*/}


                {/*    <Button  basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>*/}
                {/*    <Button  color="blue" floated="right" onClick={this.filter}>Filtriraj*/}
                {/*    </Button>*/}

                {/*</Form>*/}
                {/*<br /><br /><br />*/}
                {this.state.loaded === true ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    !this.state.loaded &&
                    <div>

                        {this.state.students.length ? <Table celled selectable compact>

                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={14} >
                                        <Grid column={2} stackable>
                                            <Grid.Column width={14}>
                                                <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['organizationalUnitName', 'lastName', 'firstName', 'fatherName', 'index', 'studyProgramSemesterName', 'studyCycleName', 'studyProgramBasicName', 'department', 'studyProgramName', 'studyTypeName', 'studentStatusName']} />
                                            </Grid.Column>
                                            <Grid.Column width={2} textAlign="center">
                                                <ExcelFile filename="Neupisani studenti" element={<Popup
                                                    trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                        <Button.Content visible>
                                                            Excel
                                                        </Button.Content>
                                                    </Button>}
                                                    content="Preuzmi spisak u Excel-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />}>
                                                    <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                                </ExcelFile>

                                            </Grid.Column>
                                        </Grid>
                                    </Table.HeaderCell>
                                </Table.Row>
                              <Table.Row>
                                    <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3}>Prezime (ime oca) ime</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Index </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Ciklus </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Odsjek </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Studijski program </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> NPP </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                           <Table.Body> {currentPosts.map((el, index) =>
                                (<Table.Row key={el.id}>

                                    <Table.Cell verticalAlign="middle" width="1">  {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}. </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle" > {el.lastName} ({el.fatherName}) {el.firstName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.index}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyCycleName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.department}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyProgramBasicName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyProgramName}</Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table> : 'Nema podataka.'}
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>}

            </div>
        );
    }
}

export default PreviousSemesterStudents;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/PreviousSemesterStudents.js